function ArticleFilter(buttons, callBack, container) {
	this.buttons = buttons;
	this.callBack = callBack;
	this.container = container;// optional

	// binds
	this.onChangeFilter = this.onChangeFilter.bind(this);

	this.buttons.forEach(button => {
		document.addEventListener('click', this.onChangeFilter);
	});
}

ArticleFilter.prototype.getCheckedButtons = function(event) {
	return this.buttons.filter(button => button.classList.contains('is-checked') || button.classList.contains('is-active'));
}

ArticleFilter.prototype.onChangeFilter = function(event) {
	if (!event.target.classList.contains('article-items-filter-button')) {
		this.closeDropDown();
		return;
	}

	if (event.target.nodeName === 'A' && ( event.target.classList.contains('is-checked') || event.target.classList.contains('is-active') ) ) {
		event.preventDefault();
	}

	if (event.target.classList.contains('is-checked') || event.target.classList.contains('is-active')) {
		this.toggleDropDown();
		return;
	}
	else {
		this.toggleDropDown();
	}

	this.buttons.forEach(button => {
		if (event.target == button) {
			button.classList.add('is-checked');
			button.classList.add('is-active');
			if( button.parentNode.nodeName == 'LI') {
				button.parentNode.classList.add('is-checked');
				button.parentNode.classList.add('is-active');
			}
		}
		else {
			button.classList.remove('is-checked');
			button.classList.remove('is-active');
			if( button.parentNode.nodeName == 'LI') {
				button.parentNode.classList.remove('is-checked');
				button.parentNode.classList.remove('is-active');
			}
		}
	})

	const checkedButtons = this.getCheckedButtons();

	if (checkedButtons.length < 1) {
		event.target.classList.add('is-checked');
		event.target.classList.add('is-active');
		if( event.target.parentNode.nodeName == 'LI') {
			event.target.parentNode.classList.add('is-checked');
			event.target.parentNode.classList.add('is-active');
		}
	}

	this.updateFilter();
};

ArticleFilter.prototype.updateFilter = function() {
	let types = [];
	let categories = [];

	this.buttons.forEach(button => {
		if (button.classList.contains('is-checked') || button.classList.contains('is-active')) {
			types.push(button.getAttribute('data-filter-type'));
			categories.push(button.getAttribute('data-filter-category'));
		}
	});

	types = types.filter(type => type);
	categories = categories.filter(category => category);

	const options = {};

	if (types && types.length > 0) {
		options.types = types;
	}

	if (categories && categories.length > 0) {
		options.categories = categories;
	}

	if(typeof this.callBack == 'function'){
		this.callBack(options);
	}
};

ArticleFilter.prototype.toggleDropDown = function() {
	if (!this.container || this.container.nodeType !== 1) {
		return;
	}

	this.container.classList.toggle('is-open');
};

ArticleFilter.prototype.closeDropDown = function() {
	if (!this.container || this.container.nodeType !== 1) {
		return;
	}

	this.container.classList.remove('is-open');
};

export default ArticleFilter;